import { z } from 'zod';
import { cuid, idParam } from './primitives.js';

/** Liga condicao a vigencia EM ABERTO da tabela (X8: condicao fora da vigencia = erro). */
export const vincularCondicaoSchema = z.object({
  condicaoId: cuid,
  isDefault: z.boolean().default(false),
});
export type VincularCondicaoDto = z.infer<typeof vincularCondicaoSchema>;

export const marcarPadraoSchema = z.object({ isDefault: z.boolean() });
export type MarcarPadraoDto = z.infer<typeof marcarPadraoSchema>;

export const tabelaCondicaoParamSchema = idParam.extend({
  condicaoId: cuid,
});

export interface TabelaCondicaoResponse {
  id: string;
  vigenciaId: string;
  condicaoId: string;
  isDefault: boolean;
  createdAt: string;
}
